import React from 'react';
export function Footer() {
  return <footer className="border-t border-rule bg-paper-alt" data-id="element-26" data-mp="32wd2qgad7ltj">
      <div className="mx-auto flex max-w-page flex-col gap-3 px-6 py-8 font-sans text-[12px] text-muted sm:flex-row sm:items-center sm:justify-between lg:px-10" data-id="element-27" data-mp="3gfiv8kpoaff6">
        <p data-id="element-28" data-mp="32m1d94cmxar9">© {new Date().getFullYear()} Prashanth Sekhar</p>
        <p data-id="element-29" data-mp="36q953aee36tp">SEBI Registered Investment Advisor · CFP · QPFP®</p>
        <p data-id="element-30" data-mp="3ufa6wespvjq0">Bengaluru, India</p>
      </div>
    </footer>;
}